<template>
  <div></div>
</template>

<script>
  export default {
      name: "Recaptcha",
      data () {
          return {
              keyDev: '6LcnKdQUAAAAADNo5MLLyvF4cCgJ2G0rjtlYD7uq',
              keyRec: '6Lczaa4cAAAAAC_giZe7v3GPIZemx1Oa4Jp1hv39',
              keyPreprod: '6LeAYV0aAAAAAGwRxsJmd-vZpxI-SK5yggt8AHRx',
              keyProd: '6LcFvWYUAAAAADjdtliiKfjNm6uySTnNrNBkFaKd',
              id: 0
          }
      },
      methods: {
          execute () {
              window.grecaptcha.execute(this.id)
          },
          reset () {
              window.grecaptcha.reset(this.id)
          },
          emitVerify (response) {
              this.$emit('verify', response)
          },
          emitExpired () {
              this.$emit('expired')
          },
          render () {
              if (window.grecaptcha) {
                  let recaptchaKey = '';
                  switch (window.location.hostname) {
                      case 'www.antargaz.fr':
                          recaptchaKey = this.keyProd;
                          break;
                      case 'preprod-www.antargaz.fr':
                          recaptchaKey = this.keyPreprod;
                          break;
                      case 'recette-antargaz.ugiintl.com':
                          recaptchaKey = this.keyRec;
                          break;
                      default:
                          recaptchaKey = this.keyDev;
                          break;
                  }
                  this.id = window.grecaptcha.render(this.$el, {
                      sitekey: recaptchaKey,
                      size: 'invisible',
                      callback: this.emitVerify,
                      'expired-callback': this.emitExpired
                  })
              }
          }
      },
      mounted () {
          if (window.grecaptcha) {
              this.render();
          } else {
              window.onloadCallback = () => this.render()
          }
      },

      beforeDestroy() {
          // Nettoyer l'instance reCAPTCHA avant la destruction du composant
          if (this.id) {
              window.grecaptcha.reset(this.id);
              this.id = 0;
          }
      }
  }
</script>

<style lang="sass">

  .grecaptcha-badge
      z-index: 1

</style>
